import MENU_ITEMS from '../constants/menu';

const cloneWithModuleDisable = (items, hasModuleAccess) => {
    if (!items) return items;
    return items.map(i => {
        const child = i.children ? cloneWithModuleDisable(i.children, hasModuleAccess) : undefined;
        const needsDisable = !!i.moduleKey && !hasModuleAccess(i.moduleKey);
        return {
            ...i,
            children: child,
            disabled: i.disabled || needsDisable
        };
    });
};

const filterByRole = (items, isAdmin = false, isSystemAdmin = false) => {
    if (!items) return items;

    return items
        .filter(item => {
            if (item.requireSystemAdminAccess && !isSystemAdmin) return false;
            if (item.requireAdminAccess && !isAdmin) return false;
            return true;
        })
        .map(item => ({
            ...item,
            children: item.children ? filterByRole(item.children, isAdmin, isSystemAdmin) : undefined,
        }))
        .filter(item => !item.children || item.children.length > 0 || item.url || item.isTitle);
};

const getMenuItems = (isAdmin = false, isAuthorized = true, hasModuleAccess = () => true, isSystemAdmin = false) => {
    // NOTE - You can fetch from server and return here as well

    // Filter out hidden menu items
    const MenuItems = MENU_ITEMS.filter(item => item.isHidden !== true);

    // BY DEFAULT return only member only menu items

    if(!isAuthorized) return [];
    const adminFiltered = filterByRole(MenuItems, isAdmin, isSystemAdmin);

    // Mark items disabled if user lacks module access (do not hide)
    return cloneWithModuleDisable(adminFiltered, hasModuleAccess);
};

const findAllParent = (menuItems, menuItem) => {
    let parents = [];
    const parent = findMenuItem(menuItems, menuItem['parentKey']);

    if (parent) {
        parents.push(parent['key']);
        if (parent['parentKey']) parents = [...parents, ...findAllParent(menuItems, parent)];
    }
    return parents;
};

const findMenuItem = (menuItems, menuItemKey) => {
    if (menuItems && menuItemKey) {
        for (var i = 0; i < menuItems.length; i++) {
            if (menuItems[i].key === menuItemKey) {
                return menuItems[i];
            }
            var found = findMenuItem(menuItems[i].children, menuItemKey);
            if (found) return found;
        }
    }
    return null;
};

export { getMenuItems, findAllParent, findMenuItem };
